
import AlertHandler from '../../../assets/js/modules/alertHandler';

export default class ConvertTo{
    constructor(url){
        this.url = null;;
    }

    async init(url){
        try {
            const response = await fetch(url)
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            console.log(data)
            if (data && data.message) {
                AlertHandler.showAlert(data.message, data.success ? 'success' : 'danger');
            }
            if (data && data.success_url) {
                setTimeout(() => {
                    window.location.href = data.success_url;
                }, 400); 
            }
        }catch (error) {
            console.error('Fehler beim Laden der Daten:', error);
        }
    }

}